/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { ActionRequest } from '@wit/vtv-x-foundation-lib';
import { StoreState } from 'store/store';

// ACTIONS
export enum ActionType {
  OFFLINE = 'status/offline',
}

type OnlineStatus = ActionRequest<ActionType.OFFLINE, { onlineStatus: boolean }>;
type Actions = OnlineStatus;

//
// CREATORS
//
const Actions = {
  onlineStatusChanged: (onlineStatus: boolean): OnlineStatus => ({
    type: ActionType.OFFLINE,
    meta: { onlineStatus },
  }),
};

export const ActionCreators = {
  onlineStatusChanged: Actions.onlineStatusChanged,
};

//
// REDUCER
//

type ReducerState = {
  onlineStatus: boolean;
};

const initialState: ReducerState = { onlineStatus: true };

export default function reducer(state = initialState, action: Actions): ReducerState {
  switch (action.type) {
    case ActionType.OFFLINE:
      return {
        ...state,
        onlineStatus: action.meta.onlineStatus,
      };
    default:
      return state;
  }
}

//
// SELECTORS
//

export const Selectors = {
  isOnline: (state: StoreState): boolean => state.offline.onlineStatus,
};
